import { render, staticRenderFns } from "./NewsEnglish.vue?vue&type=template&id=b4dc108a&scoped=true&"
import script from "./NewsEnglish.vue?vue&type=script&lang=js&"
export * from "./NewsEnglish.vue?vue&type=script&lang=js&"
import style0 from "./NewsEnglish.vue?vue&type=style&index=0&id=b4dc108a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dc108a",
  null
  
)

export default component.exports